import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BackChevronIconSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import QrIconSvg from '../../../assets/icons/icon-referral-bonus-qr.svg?react';
import { BaseButton } from '../../../shared/ui';

type ReferralBonusHeaderProps = {
  onBack: () => void;
  onOpenQr?: () => void;
};

const Header = styled.header.attrs({
  'data-ui': 'referral-bonus-header',
})`
  min-height: ${({ theme }) => theme.scale.px(36)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackButton = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  place-items: center;
`;

const BackChevronIcon = styled(BackChevronIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(20)};

  & path {
    stroke: ${({ theme }) => theme.colors.text.primary};
  }
`;

const QrButton = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(39)};
  height: ${({ theme }) => theme.scale.px(39)};
  display: grid;
  place-items: center;

  &:disabled {
    opacity: 0.4;
  }
`;

const QrIcon = styled(QrIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: 100%;
  height: 100%;
`;

export function ReferralBonusHeader({
  onBack,
  onOpenQr,
}: ReferralBonusHeaderProps) {
  const { t } = useTranslation();

  return (
    <Header>
      <BackButton
        type="button"
        aria-label={t('referralBonus.backAria')}
        onClick={onBack}
      >
        <BackChevronIcon />
      </BackButton>
      <QrButton
        type="button"
        aria-label={t('referralBonus.openQrAria')}
        onClick={onOpenQr}
        disabled={!onOpenQr}
      >
        <QrIcon />
      </QrButton>
    </Header>
  );
}
